import ToastActions from 'actions/ToastActions';

export function diffSourcesByLinked(oldSources: Array<any>, newSources: Array<any>): any {
  const newlyLinked: any = {};
  const unlinked: any = {};

  const linkableSourcesByProvider = (sources: any[]) =>
    sources
      // Get rid of blank sources and any sources that don't have account linking
      //   Had to use reduce instead of filter to appease flow:
      //   https://github.com/facebook/flow/issues/1414#issuecomment-239100144
      .reduce((ss: any, s: any) => (s && s.linkedAccountInfo ? ss.concat(s) : ss), [])
      // Turn those sources into singleton objects using the providerKey as the key
      .map((s: any) => {
        const obj: any = {};
        obj[s.providerKey] = s;
        return obj;
      })
      // Merge all the objects together
      .reduce((acc: any, x: any) => Object.assign(acc, x), []);

  const oldSourcesByProvider = linkableSourcesByProvider(oldSources);
  const newSourcesByProvider = linkableSourcesByProvider(newSources);

  // Had to use Object.keys instead of Object.values to appease flow:
  // https://github.com/facebook/flow/issues/2221
  Object.keys(newSourcesByProvider).forEach((newSourceKey) => {
    const newSource = newSourcesByProvider[newSourceKey];
    const oldSource = oldSourcesByProvider[newSource.providerKey];
    if (!oldSource) {
      return;
    }

    const oldLinked = oldSource.linkedAccountInfo.isLinked;
    const newLinked = newSource.linkedAccountInfo.isLinked;
    if (newLinked && !oldLinked) {
      newlyLinked[newSource.providerKey] = newSource;
    } else if (!newLinked && oldLinked) {
      unlinked[newSource.providerKey] = newSource;
    }
  });

  return {
    newlyLinked,
    unlinked,
  };
}

export function showAccountLinkingToastsForDiff(diff: any) {
  // Had to use Object.keys instead of Object.values to appease flow:
  // https://github.com/facebook/flow/issues/2221
  Object.keys(diff.newlyLinked).forEach((providerKey) => {
    const source = diff.newlyLinked[providerKey];
    ToastActions.showSuccessToast(`Your ${source.title} account has been successfully linked`);
  });

  // Had to use Object.keys instead of Object.values to appease flow:
  // https://github.com/facebook/flow/issues/2221
  Object.keys(diff.unlinked).forEach((providerKey) => {
    const source = diff.unlinked[providerKey];
    ToastActions.showSuccessToast(`Your ${source.title} account has been successfully unlinked`);
  });
}

export function showAccountLinkingToasts(oldSources: Array<any>, newSources: Array<any>) {
  const diff = diffSourcesByLinked(oldSources, newSources);
  showAccountLinkingToastsForDiff(diff);
}
